import { render, staticRenderFns } from "./Keywordialog.vue?vue&type=template&id=f82732cc&scoped=true"
import script from "./Keywordialog.vue?vue&type=script&lang=js"
export * from "./Keywordialog.vue?vue&type=script&lang=js"
import style0 from "./Keywordialog.vue?vue&type=style&index=0&id=f82732cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82732cc",
  null
  
)

export default component.exports